import React, { useState, useRef } from 'react';
import { useUploadS3Mutation } from '../../app/api';
import { Alert, Form, Button, Card, Spinner } from 'react-bootstrap';
import { useAllImagesQuery } from '../../app/api';
import {Row} from 'react-bootstrap';
import ImageCard from './ImageCard';

export default function ImageGallery() {
  const [uploading, setUploading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [imageUrl, setImageUrl] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [metadata, setMetaData] = useState(null);

  const [uploadS3] = useUploadS3Mutation();

  const titleRef = useRef();
  const categoryRef = useRef();

  const {data: images, refetch: runRefetchImages} = useAllImagesQuery();

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setError('');
      setSuccess('');
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    
    if (!selectedFile) {
      setError('Please select a file first');
      return;
    }

    if (titleRef.current.value == '' ) {
      setError('Please enter descriptive fields');
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);

    setUploading(true);
    setError('');
    setSuccess('');

    try {
    
      const newCategory = categoryRef.current.value;

      const response = await uploadS3({
        title: titleRef.current.value, 
        category: newCategory, 
        body: formData
      });

      if (!response || !response.data.message.includes('success')) {
        throw new Error('Upload failed');
      }

      setImageUrl(response.data.filename);
      setImageUrl('https://ffn-email-design.s3.us-west-2.amazonaws.com/' + response.data.filename)
      setSuccess('File uploaded successfully!');
      setMetaData({title: titleRef.current.value, category: categoryRef.current.value});
      titleRef.current.value = '';
      categoryRef.current.value = '';
    } catch (error) {
      console.error('Error uploading file:', error);
      setError('Failed to upload file. Please try again.');
    } finally {
      setUploading(false);
    }
  };

  const rerun = () => {
    console.log('running rerun');
    runRefetchImages();
  }

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <Card>
            <Card.Header>
              <h5 className="mb-0">Upload Image to Gallery</h5>
            </Card.Header>
            <Card.Body>
              {error && <Alert variant="danger">{error}</Alert>}
              {success && <Alert variant="success">{success}</Alert>}

              <Form onSubmit={handleUpload}>
                <Form.Group className="mb-3">
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    ref={titleRef}
                    type="text"
                    name="title"
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Category</Form.Label>
                  <Form.Select
                    ref={categoryRef}
                    name="category"
                  >
                    <option value="header">Header</option>
                    <option value="body">Body</option>
                    <option value="footer">Footer</option>
                  </Form.Select>
                </Form.Group>
                <div className="upload-area p-4 bg-light border rounded text-center mb-4">
                  <div className="mb-3">
                    <h6 className="mb-2">Click to select a file</h6>
                    <p className="text-muted small">PNG, JPG, GIF up to 1MB</p>
                  </div>

                  <Form.Group className="mb-3">
                    <Form.Control
                      type="file"
                      onChange={handleFileSelect}
                      accept="image/*"
                      disabled={uploading}
                    />
                  </Form.Group>

                  {selectedFile && (
                    <div className="selected-file mb-3">
                      <p className="text-success mb-1">
                        <i className="bi bi-check-circle me-2"></i>
                        File selected: {selectedFile.name}
                      </p>
                      <p className="text-muted small">
                        Size: {(selectedFile.size / 1024 / 1024).toFixed(2)} MB
                      </p>
                    </div>
                  )}

                  <Button 
                    type="submit"
                    variant={uploading ? 'secondary' : 'primary'}
                    disabled={uploading}
                  >
                    {uploading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                        Uploading...
                      </>
                    ) : (
                      'Upload File'
                    )}
                  </Button>
                </div>
              </Form>

              {imageUrl && (
                <div className="mt-4">
                  <h6 className="mb-3">Uploaded Image:</h6>
                  <div className="text-center">
                    <img
                      src={imageUrl}
                      alt="Uploaded preview"
                      className="img-fluid rounded mb-3"
                      style={{ maxHeight: '300px' }}
                    />
                    <div className="text-muted">
                      <p className="mb-1"><strong>Title:</strong> {metadata.title}</p>
                      {metadata.category && (
                        <p className="mb-1"><strong>Category:</strong> {metadata.category}</p>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </Card.Body>
          </Card>
        </div>
      </div>
       <br/>
       <br/>
       <center>
         <h2>Existing Images</h2>
       </center>
       <br/>
       <br/>
       <Row>
          {images && images.map((image) => (
            <ImageCard image={image} key={image.id} rerun={rerun} />
          ))}
        </Row>
    </div>
  );
}